export default {
  enderecoCobranca: state => state.enderecoCobranca
}
